import { LitElement, css, html } from 'lit';
import { ObjectId, UserTag } from '../../types';
import { customElement, property } from 'lit/decorators';

import { StateController } from '../../helpers/state/state-management/state-controller';
import { getVisibleTextColor } from '../../helpers/colors';
import topicData from '../../helpers/state/topic-data';

@customElement('tags-selector')
export class TagsSelector extends LitElement {
    @property({ type: Array })
    selectedTags: ObjectId[] = [];

    @property({ type: Boolean })
    isWriter: boolean = false;

    @property({ type: Boolean })
    enableTranslate: boolean = false;

    private readonly bindTopicState = new StateController(this, topicData);

    private async removeTag(tagToRemove: UserTag) {
        this.dispatchEvent(
            new CustomEvent('remove-tag', {
                detail: tagToRemove,
            })
        );
    }

    private async directAdd(newTag: UserTag) {
        this.dispatchEvent(
            new CustomEvent('add-new-tag', {
                detail: newTag,
            })
        );
    }

    protected render() {
        return html`
            <div class="tags__wrapper">
                ${topicData.allUserTags?.map((item) => {
                    const tagAdded = this.selectedTags.some(tag => tag.$oid === item._id?.$oid);
                    const canView = this.isWriter ? true : item.can_crowdsource ?? true;
                    if (!canView) return '';
                    return html`
                        <div class="tag__item"
                            style="${tagAdded ? `background-color: ${item.icon}; color: ${getVisibleTextColor(item.icon)}` : `background-color: #fff; border: 2px solid ${item.icon};`}"
                            @click=${tagAdded ? async () => await this.removeTag(item): async() => await this.directAdd(item)}>
                            ${this.enableTranslate ?
                                html`<translated-span>${item.name}</translated-span>`
                                : html`${item.name}`}
                            <div class="tag__icon">${tagAdded ? String.fromCodePoint(0x2D) : String.fromCodePoint(0x2B)}</div>
                        </div>
                    `;
                }
                )}
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --icon-background-color: var(--theme-white-color);
                --icon-inner-color: var(--main-primary-color);
            }

            .tags__wrapper {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
            }

            .tag__item {
                position: relative;
                user-select: none;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 3px 14px;
                border-radius: 1.25rem;
                margin-right: 6px;
                margin-bottom: 4px;
                font-size: 10px;
                border: 1px solid var(--main-primary-color);
            }

            .tag__icon {
                border-radius: 999px;
                width: 1rem;
                height: 1rem;
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -5px;
                right: -5px;
                background: var(--theme-white-color);
                border: 1px solid var(--main-primary-color);
                color: var(--main-primary-color);
            }
        `;
    }
}
